module.exports = __webpack_public_path__ + "static/media/nerves.8b678589.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/nerves.jpg
// module id = 259
// module chunks = 0